import React from 'react'
import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../../helpers/value'

export const CustomTooltip = ({ label, list }) => {
  const renderItem = ({
    label,
    value,
    unit,
    formatValue,
    formatValueColor,
    isI18n,
  }) => {
    return (
      <div className="dFlex justifyContentBetween gap4">
        <div>{isI18n ? <Translate value={label} /> : label}</div>
        <div>
          <span
            className="fw500"
            style={{
              whiteSpace: 'nowrap',
              color: formatValueColor && formatValueColor(value),
            }}
          >
            {formatValue ? formatValue(value) : value}
            {unit && <> {unit}</>}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="fstItalic mb1">{formatText(label)}</div>

      {list.map((item, index) => {
        return <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
      })}
    </div>
  )
}
